// extracted by mini-css-extract-plugin
export default {"container":"Page404__container-x7u6u"};